export const book = {
    UNLOAD:                     'website/book/UNLOAD',
    REQUEST_USER_SESSION:       'website/book/REQUEST_USER_SESSION',
    RECEIVE_USER_SESSION:       'website/book/RECEIVE_USER_SESSION',
    REQUEST_SERVICE_LIST:       'website/book/REQUEST_SERVICE_LIST',
    RECEIVE_SERVICE_LIST:       'website/book/RECEIVE_SERVICE_LIST',
    REQUEST_SERVICE_DATA:       'website/book/REQUEST_SERVICE_DATA',
    SHOW_ADD_SERVICE:           'website/book/SHOW_ADD_SERVICE',
    CLOSE_ADD_SERVICE:          'website/book/CLOSE_ADD_SERVICE',
    ADD_SERVICE_DATA:           'website/book/ADD_SERVICE_DATA',
    SUBMIT_END_USER:            'website/book/SUBMIT_END_USER',
    EDIT_END_USER:              'website/book/EDIT_END_USER',
    SUBMIT_SERVICE:             'website/book/SUBMIT_SERVICE',
    CANCEL_ADD_SERVICE:         'website/book/CANCEL_ADD_SERVICE',
    REMOVE_SERVICE:             'website/book/REMOVE_SERVICE',
    ADD_SERVICE_ITEM:           'website/book/ADD_SERVICE_ITEM',
    SUBMIT_SERVICE_ITEM:        'website/book/SUBMIT_SERVICE_ITEM',
    REMOVE_SERVICE_ITEM :       'website/book/REMOVE_SERVICE_ITEM',
    SORT_SERVICE_ITEMS:         'website/book/SORT_SERVICE_ITEMS',
    REQUEST_ROUTES:             'website/book/REQUEST_ROUTES',
    RECEIVE_ROUTES:             'website/book/RECEIVE_ROUTES',
    REQUEST_HIKES:              'website/book/REQUEST_HIKES',
    RECEIVE_HIKES:              'website/book/RECEIVE_HIKES',
    RECEIVE_THEMES:             'website/book/RECEIVE_THEMES',
    REQUEST_THEMES:             'website/book/REQUEST_THEMES',
    REQUEST_SHUTTLE_LINES:      'website/book/REQUEST_SHUTTLE_LINES',
    RECEIVE_SHUTTLE_LINES:      'website/book/RECEIVE_SHUTTLE_LINES',
    TOGGLE_EDIT_SERVICE_ITEM:   'website/book/TOGGLE_EDIT_SERVICE_ITEM',
    UPDATE_SERVICE_ITEM:        'website/book/UPDATE_SERVICE_ITEM',
    UNSELECT_SERVICE:           'website/book/UNSELECT_SERVICE',
    CHANGE_COMMENT:             'website/book/CHANGE_COMMENT',
    SHOW_SUBMIT:                'website/book/SHOW_SUBMIT',
    SUBMIT:                     'website/book/SUBMIT',
    SUBMIT_SUCCESS:             'website/book/SUBMIT_SUCCESS',
    SUBMIT_FAILURE:             'website/book/SUBMIT_FAILURE',
    SUBMIT_DRAFT:               'website/book/SUBMIT_DRAFT',
    SUBMIT_DRAFT_SUCCESS:       'website/book/SUBMIT_DRAFT_SUCCESS',
    SUBMIT_DRAFT_FAILURE:       'website/book/SUBMIT_DRAFT_FAILURE',
    CANCEL:                     'website/book/CANCEL',
    TERMS_READED:               'website/book/TERMS_READED',
    TERMS_ACCEPTED:             'website/book/TERMS_ACCEPTED',
    TERMS_REJECTED:             'website/book/TERMS_REJECTED',
    LOAD_SESSION:               'website/book/LOAD_SESSION',
    REQUEST_DRAFT_QUOTE:        'website/book/REQUEST_DRAFT_QUOTE',
    RECEIVE_DRAFT_QUOTE:        'website/book/RECEIVE_DRAFT_QUOTE',
    RECEIVE_DRAFT_QUOTE_ERROR:  'website/book/RECEIVE_DRAFT_QUOTE_ERROR',
    REQUEST_OPTIMALLE:        'website/book/REQUEST_OPTIMALLE',
    RECEIVE_OPTIMALLE:        'website/book/RECEIVE_OPTIMALLE',
    RECEIVE_OPTIMALLE_ERROR:  'website/book/RECEIVE_OPTIMALLE_ERROR',
    SET_STAGE:                  'website/book/SET_STAGE',
    REQUEST_DRAFT_COUNT:        'website/book/REQUEST_DRAFT_COUNT',
    RECEIVE_DRAFT_COUNT:        'website/book/RECEIVE_DRAFT_COUNT',
    SUBMIT_CLIENT_DATA:         'website/book/SUBMIT_CLIENT_DATA',
    REQUEST_EXISTING_BOOKING:   'website/book/REQUEST_EXISTING_BOOKING',
    RECEIVE_EXISTING_BOOKING:   'website/book/RECEIVE_EXISTING_BOOKING',
};

export const map = {
    DISPLAY_STOPS : 'carto/DISPLAY_STOPS',
    REQUEST_STOPS : 'carto/REQUEST_STOPS',
    RECEIVE_STOPS : 'carto/RECEIVE_STOPS',
    REQUEST_PLAN_STEPS : 'carto/REQUEST_PLAN_STEPS',
    RECEIVE_PLAN_STEPS : 'carto/RECEIVE_PLAN_STEPS',
    MOSE_HOVER_STOP : 'carto/MOSE_HOVER_STOP',
    SELECT_DEPARTURE_STEP : 'carto/SELECT_DEPARTURE_STEP',
    SELECT_ARRIVAL_STEP : 'carto/SELECT_ARRIVAL_STEP',
    SET_KML_DATA : 'carto/SET_KML_DATA',
    UPDATE_FILTERS : 'carto/UPDATE_FILTERS',
    SELECT_STEP : 'carto/SELECT_STEP',
    EDIT_STEP : 'carto/EDIT_STEP',
    SAVE_STEP : 'carto/SAVE_STEP',
    DELETE_STEP : 'carto/DELETE_STEP',
    NEW_STEP : 'carto/NEW_STEP',
    ADD_STEP : 'carto/ADD_STEP',
    SAVE_STOP : 'carto/SAVE_STOP',
    SELECT_STOP : 'carto/SELECT_STOP',
    TOGGLE_SUMMARY : 'carto/TOGGLE_SUMMARY',
    MOVE_HIKER_MARKER : 'carto/MOVE_HIKER_MARKER',
    SELECT_HIKE : 'carto/SELECT_HIKE',
    MOSE_OVER_HIKE : 'carto/MOSE_OVER_HIKE',
    SELECT_THEME : 'carto/SELECT_THEME',
    START_TRIP_EDIT : 'carto/START_TRIP_EDIT',
    CANCEL_TRIP_EDIT : 'carto/CANCEL_TRIP_EDIT',
    CHANGE_MAP_LAYER : 'carto/CHANGE_MAP_LAYER',
    UPDATE_BOUNDS : 'carto/UPDATE_BOUNDS',
    REFRESH_BOUNDS : 'carto/REFRESH_BOUNDS',
    REQUEST_THEMES : 'carto/REQUEST_THEMES',
    RECEIVE_THEMES : 'carto/RECEIVE_THEMES',
    REQUEST_HIKE_STEPS : 'carto/REQUEST_HIKE_STEPS',
    RECEIVE_HIKE_STEPS : 'carto/RECEIVE_HIKE_STEPS',
    PRESELECT_HIKE: 'carto/PRESELECT_HIKE',
    SET_DIRECTION: 'carto/SET_DIRECTION',
    ADD_SERVICE_FROM_SESSION: 'carto/ADD_SERVICE_FROM_SESSION',
}